import type { Supervisor } from '@@partner:types:app'
import type { CRUD_Variables, GQL_Edge } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_EMPLOYEE_FIELDS,
  SHORTCUT_PAGE_INFO_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllSupervisorsQueryResult {
  supervisors: GQL_Edge<Supervisor[]>
}

export interface AllSupervisorsQueryVariables extends CRUD_Variables {}

const GQL_QUERY_EMPLOYEES_STATS = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    supervisors: allSupervisors(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        ${SHORTCUT_EMPLOYEE_FIELDS}
        email
        shops {
          id
          name
        }
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllSupervisors = (
  variables: AllSupervisorsQueryVariables
) =>
  useQuery<AllSupervisorsQueryResult, AllSupervisorsQueryVariables>(
    GQL_QUERY_EMPLOYEES_STATS,
    { variables, fetchPolicy: 'cache-and-network' }
  )
